<template>
    <div class="container-fluid position-relative bg-white d-flex p-0">
        <LeftSideBar/>

        <!-- ============================================================== -->
        <!-- Page wrapper  -->
        <!-- ============================================================== -->
        <div class="content">
            <NavBarView/>
            <slot></slot>
            <FooterView/>
        </div>
        <!-- ============================================================== -->
        <!-- End Page wrapper  -->
        <!-- ============================================================== -->
    </div>
</template>

<script>
    import FooterView from '@/components/FooterView.vue'
    import NavBarView from '@/components/NavBarView.vue'
    import LeftSideBar from '@/components/LeftSideBar.vue'
    export default {
        name:"DashView",
        components:{
            NavBarView,
            LeftSideBar,
            FooterView
        },
        mounted() {
        // Sélectionnez l'élément avec la classe 'sidebar-toggler'
        const sidebarToggler = this.$el.querySelector('.sidebar-toggler');

        // Attachez un gestionnaire d'événements au clic sur cet élément
        sidebarToggler.addEventListener('click', this.toggleSidebar);
    },
    methods: {
        // Méthode pour basculer la classe 'open' sur les éléments '.sidebar' et '.content'
        toggleSidebar() {
            const sidebar = this.$el.querySelector('.sidebar');
            const content = this.$el.querySelector('.content');

            if (sidebar.classList.contains('open') || content.classList.contains('open')) {
            sidebar.classList.remove('open');
            content.classList.remove('open');
            } else {
            sidebar.classList.add('open');
            content.classList.add('open');
            }
        }
    }
    }
</script>

<style>
.fa,.far,.fas{color:#00C853;}
.required {color: red;margin-left: 5px;}
.bgbadge{background-color: #00C853;}
router-link {text-decoration: none;}

/* Styles pour le preloader */
.modal-preloader {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px; /* Ajuste la hauteur selon tes besoins */
}

.modal-preloader .spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 2s linear infinite;
}

/* Animation du preloader */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.table-wrapper {
    max-height: 450px; 
    overflow-y: auto; 
    overflow-x: auto; 
}
</style>